/**
 * Lifecycle Service
 *
 * The single source of the "active / inactive" semantics for any entity that
 * carries an `inactivationDate` (+ the denormalized `active` flag). Pure
 * TypeScript — shared by web (console) and mobile (RN).
 *
 * See `types/lifecycle.ts` for the model (date is authoritative; `active` is a
 * queryable cache recomputed on save).
 */
/** Coerce a Date | ISO-string | null | undefined into a Date or null. */
function toDate(value) {
    if (value == null || value === '')
        return null;
    const d = value instanceof Date ? value : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}
class LifecycleService {
    /**
     * Effective active state. `true` when there is no inactivation cutoff or the
     * cutoff is still in the future. Accepts Date or ISO string for resilience.
     */
    isActive(entity, now = new Date()) {
        const date = toDate(entity.inactivationDate);
        return date === null || date > now;
    }
    /**
     * Recompute the denormalized `active` flag from `inactivationDate`. Call before
     * persisting so the queryable cache stays consistent with the cutoff.
     */
    stampActive(entity, now = new Date()) {
        return { ...entity, active: this.isActive(entity, now) };
    }
    /**
     * Coarse server-side filter for "intended active" (`active == true`). This is
     * a superset: a scheduled cutoff that has elapsed since the last save still
     * matches, so refine with `isActive(now)` on the result when precision matters.
     */
    activeFilter() {
        return [{ field: 'active', operator: '==', value: true }];
    }
}
export const lifecycleService = new LifecycleService();
//# sourceMappingURL=lifecycleService.js.map